// AyaProLogo — asset officiel de marque AYA PRO (fichier fourni, fond transparent) (v5.26.0).
// RÈGLE : un seul asset (/aya/branding/aya-pro-logo.png), jamais recréé ni déformé.
// Lettres AYA blanches → sur fond clair, utiliser la variante onLight (pastille vert AYA,
// surface officielle autorisée par la charte).
const SRC = "/aya/branding/aya-pro-logo.png";
const HEIGHTS = { hero: 44, header: 30, onboarding: 24, dashboard: 26, compact: 18 };

export const AyaProLogo = ({ variant = "header", onLight = false, style = {}, ...rest }) => {
  const h = HEIGHTS[variant] || 28;
  const img = (
    <img src={SRC} alt="AYA PRO" draggable={false} data-testid={`aya-pro-logo-${variant}`}
      style={{ height: h, width: "auto", objectFit: "contain", display: "block", ...(onLight ? {} : style) }} {...rest} />
  );
  if (!onLight) return img;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", background: "#06281A", borderRadius: 9, padding: `${Math.round(h * 0.22)}px ${Math.round(h * 0.45)}px`, ...style }}>
      {img}
    </span>
  );
};
